import SparklineChart from './SparklineChart';
import { formatLargeNumber, formatPrice, formatPercentageChange } from '../utils/formatUtils';
import ChangeIndicator from './ChangeIndicator';
import XIcon from "../assets/x.svg";
import UpIcon from "../assets/green-tri.svg";
import DownIcon from "../assets/red-tri.svg";

export default function CoinDetailsModal({ id, detail, image, name, symbol, price, marketCap, volume, onClose, onTradeClick }) {
  const change = detail.price_change_percentage_24h;
  const Icon = change >= 0 ? UpIcon : DownIcon;

  return (
    <div className="hidden lg:flex items-center justify-center fixed inset-0 bg-black/50 z-50">
      <div className="w-full max-w-3xl bg-white p-6 rounded-lg relative">
        <button onClick={onClose} className="absolute top-4 right-4">
          <img src={XIcon} alt='close icon' className="h-8 w-8" />
        </button>

        <>
          <div className="flex gap-x-2 text-2xl font-bold"><img src={image} alt="coin logo" className="h-8 w-8" />{name}</div>
          <div className="flex items-baseline ml-10">
            <p className="text-2xl font-bold mr-2">${formatPrice(price)}</p>
            <div className={`flex justify-start items-center text-base ${change >= 0 ? 'text-green-500' : 'text-red-500'}`}>
              <img src={Icon} alt="change indicator" className="w-4 h-4 mr-1" />{formatPercentageChange(detail.price_change_percentage_24h)}
            </div>
          </div>
        </>

        <div className="grid grid-cols-3 gap-4 ml-10 mt-6">
          <div>
            <span className="font-bold">24h High</span>
            <div>{formatPrice(detail.high_24h)}</div>
          </div>
          <div>
            <span className="font-bold">24h Low</span>
            <div>{formatPrice(detail.low_24h)}</div>
          </div>
          <div>
            <span className="font-bold">All-Time High</span>
            <div>{formatPrice(detail.ath)}</div>
          </div>
          <div>
            <span className="font-bold">Market Cap</span>
            <div>{formatLargeNumber(marketCap)}</div>
          </div>
          <div>
            <span className="font-bold">24h Volume</span>
            <div>{formatLargeNumber(volume)}</div>
          </div>
          <div>
            <span className="font-bold">In Circulation</span>
            <div>{formatLargeNumber(detail.circulating_supply)}</div>
          </div>
        </div>

        <SparklineChart data={detail.sparkline_in_7d} />

        <div className="flex justify-evenly text-center mt-6">
          {["24h", "7d", "30d", "1y"].map((label, idx) => {
            const value = [detail.price_change_percentage_24h, detail.price_change_percentage_7d, detail.price_change_percentage_30d, detail.price_change_percentage_1y][idx];
            return (
              <div className="flex flex-col" key={label}>
                <span className="font-bold">{label}</span>
                <ChangeIndicator value={value} />
              </div>
            );
          })}
        </div>

        <div className="flex gap-x-6 mt-6">
          <button onClick={() => {
            onTradeClick({ id, name, symbol, current_price: price });
            onClose();
          }}
          className="w-full bg-blue-500 text-white font-bold py-3 rounded-full">
            Trade
          </button>
          <button onClick={onClose} className="w-full bg-stone-200 font-bold py-3 rounded-full">
            Close
          </button>
        </div>
      </div>
    </div>
  );
}